// 系统角色枚举值
export const ROLE_MAP = {
  juror: 'JUROR',
  judge: 'COURT_STAFF',
  admin: 'ADMIN'
}

// sessionStorage中存储的当前租户信息的key值
export const currentTenant = 'CURRENT_TENANT'



// WEBPACK FOOTER //
// ./src/constants/index.js